var chargeMap = {
  charge: 'charge',
  additionalInfo: 'additionalInfo',
  error: 'error'
};
export default chargeMap;